import { useEffect, useState } from "react";
import {
  enDaily,
  enMonthly,
  enWeekly,
  formatDate,
  formatDateNum,
  formatMonth,
  formatWeek,
  formatYear,
} from "../../functions/DateConverter";
import { useDispatch } from "react-redux";
import { totalThunks } from "../../store/salesApiSlice";
import { useNavigate } from "react-router-dom";

function CalendarContent(props) {
  // props.currentDate = 2024-오늘-날짜
  let date = new Date(props.currentDate);
  let dateList = [];
  let monthList = [];
  let finalMap = {};
  let i = 0;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isMonthSelect, setIsMonthSelect] = useState(false);
  const [currentMonth, setCurrentMonth] = useState("");
  const [enCurrentMonth, setEnCurrentMonth] = useState("");
  const HandleMonthSelect = (cur) => {
    setIsMonthSelect(!isMonthSelect);
    setCurrentMonth(cur);
  };

  const HandleDispatch = (date, page) => {
    props.open();
    if (props.onSelectDate) {
      // RankPage 에서 넘긴 콜백: dispatch(fetchRanking) & 달력 닫기
      props.onSelectDate(date);
    } else {
      // DetailPage 전용: 기존 매출 슬라이스 호출 + navigate
      dispatch(totalThunks(date));
      if (props.detail) {
        navigate("/detail", {
          state: { currentDate: date, page, pageType: props.detail },
        });
      }
    }
  };

  // 이번 달부터 1년 전까지의 년월 추가하는 코드
  let currdate = new Date(); // 현재 날짜
  currdate.setDate(1); // 해당 월의 첫째 날로 설정

  for (let i = 0; i < 12; i++) {
    // dateList에 해당 월의 첫째 날 추가
    dateList.push(new Date(currdate));

    // monthList에 년월 추가 (예: 2025 February)
    monthList.push(`${formatYear(currdate)} ${formatMonth(currdate)}`);

    // 이전 달로 이동
    currdate.setMonth(currdate.getMonth() - 1);
  }

  dateList.forEach((element, index) => {
    let list = [];
    const elemDate = new Date(element);
    //해당 월의 첫날(2024년 7월 1일)
    const firstDayOfMonth = new Date(
      elemDate.getFullYear(),
      elemDate.getMonth(),
      1
    );
    //해당 월의 마지막 날 (31일)
    const lastDayOfMonth = new Date(
      elemDate.getFullYear(),
      elemDate.getMonth() + 1,
      0
    );
    const daysInMonth = lastDayOfMonth.getDate();
    // 해당 월의 첫 날이 속한 주의 시작일(일요일) 구하기
    const startOfWeek = new Date(firstDayOfMonth);
    startOfWeek.setDate(firstDayOfMonth.getDate() - firstDayOfMonth.getDay());
    switch (props.page) {
      case "daily":
        for (let day = 1; day <= daysInMonth; day++) {
          const thisDate = new Date(
            elemDate.getFullYear(),
            elemDate.getMonth(),
            day
          );
          if (thisDate <= new Date()) {
            list.push(formatDate(thisDate));
          }
        }
        finalMap[monthList[index]] = list;
        break;
      case "weekly":
        // 주 단위로 날짜를 추가
        let cnt = 1;
        for (
          let thisDate = startOfWeek;
          thisDate <= lastDayOfMonth;
          thisDate.setDate(thisDate.getDate() + 1)
        ) {
          // 토요일인 경우 주 배열에 추가하고 초기화
          if (thisDate.getDay() === 6 || thisDate >= lastDayOfMonth) {
            list.push(formatDate(thisDate));
            // formatWeek(formatDate(thisDate))
          }
        }
        finalMap[monthList[index]] = list;
        break;
    }
  });

  useEffect(() => {
    setIsMonthSelect(false);
  }, []);

  return (
    <div className="p-5 w-[260px] max-h-[500px] overflow-y-scroll rounded-[25px] border border-[#e4e4e4] bg-white z-[1]">
      <div className="flex justify-between text-[4vw]">
        <div className="flex items-center justify-end text-left font-semibold text-[4.5vw] mb-[5vw] text-black">
          {props.t("calendar.selectMonth")}
        </div>
        <div
          className="text-[#287398]"
          onClick={() => props.open()}
          style={{ color: "black", fontSize: "4.5vw" }}
        >
          X
        </div>
      </div>
      <div className="min-h-72 text-[4vw]">
        {isMonthSelect ? (
          <div className="min-h-72 text-[4vw]">
            <div
              className="side-nav__content side-pick"
              id="calendar"
              onClick={() => {
                setIsMonthSelect(false);
              }}
            >
              {props.i18n.language === "ko" ? currentMonth : enCurrentMonth}
            </div>
            {finalMap[currentMonth].map((date, index) => (
              <div
                key={date}
                className="side-nav__content side_detail-date"
                id="calendar"
                onClick={() => {
                  props.open();
                  HandleDispatch(date, props.page);
                }}
              >
                {props.page === "daily" && props.i18n.language === "ko"
                  ? formatDateNum(date)
                  : props.page === "weekly" && props.i18n.language === "ko"
                  ? formatWeek(date)
                  : props.page === "daily" && props.i18n.language === "en"
                  ? enDaily(date)
                  : props.page === "weekly" && props.i18n.language === "ko"
                  ? enWeekly(date)
                  : ""}
              </div>
            ))}
          </div>
        ) : (
          dateList.map((date, index) => (
            <div key={date.toISOString()}>
              <div
                className="side-nav__content"
                id="calendar"
                onClick={() => {
                  props.page === "monthly"
                    ? HandleDispatch(formatDate(date), props.page)
                    : HandleMonthSelect(
                        `${formatYear(date)} ${formatMonth(date)}`
                      );
                  setEnCurrentMonth(`${enMonthly(date)}`);
                }}
              >
                {props.i18n.language === "ko"
                  ? `${formatYear(date)} ${formatMonth(date)}`
                  : `${enMonthly(date)}`}
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
}

export default CalendarContent;
